export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/about-center.6e0930af-7c8015.png";